import {Alert} from 'platform/components';
import {Box} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import type {VehicleOrderFactoryHoldResponseBody} from '@dms/api/new-vehicle';
import i18n from '@dms/i18n';

import {buildArray, parseDate} from 'shared/web';

type FactoryHoldNoteProps = {
  hold: VehicleOrderFactoryHoldResponseBody;
};

/** Reason and expected release of a factory hold; information only, the order needs no action. */
export function FactoryHoldNote(props: FactoryHoldNoteProps) {
  const formatDate = useDateTimeFormatter();
  const lines = buildArray<string>()
    .when(
      isNotNilOrEmpty(props.hold.reason),
      () => `${i18n.t('entity.newVehicle.order.factoryHoldReason')}: ${props.hold.reason}`
    )
    .whenNotNil(
      props.hold.expectedReleaseDate,
      (date) =>
        `${i18n.t('entity.newVehicle.order.factoryHoldExpectedRelease')}: ${formatDate('dateMedium', parseDate(date))}`
    );

  if (lines.length === 0) {
    return null;
  }

  return (
    <Box data-testid="new-vehicle-factory-hold">
      <Alert variant="info" type="inline" message={lines} />
    </Box>
  );
}
